import { TRANSACTIONS, TRANSACTIONS_PAGINATE, TRANSACTIONS_PARAMS,
  TRANSACTIONS_UPDATE, TRANSACTIONS_QUERY, NOTIFICATIONS_INCLUDE } from '@store/types'
import shortly from 'vuex-shortly'
import graphQL from '@graphQL'
import transactionsQuery from '@graphQL/queries/UserTransactions'
import axios from 'axios'

const state = {
  list: [],
  details: {},
  paginate: {},
  params: {
    search: ''
  }
}

const getters = {
  [TRANSACTIONS]: 'list',
  [TRANSACTIONS_PAGINATE]: 'paginate',
  [TRANSACTIONS_PARAMS]: 'params'
}

const mutations = {
  [TRANSACTIONS]: 'list',
  [TRANSACTIONS_PAGINATE]: 'paginate',
  [TRANSACTIONS_QUERY]: (state, payload) => {
    state.params.search = payload
  }
}

const actions = {
  [TRANSACTIONS]: async ({ commit }, payload = {}) => {
    const response = await graphQL(transactionsQuery, payload)
    const { data: transactions, ...paginate } = response?.data?.data?.usersTransactions || {}
    commit(TRANSACTIONS, transactions)
    commit(TRANSACTIONS_PAGINATE, paginate)
  },
  [TRANSACTIONS_UPDATE]: async ({ dispatch }, transaction_id) => {
    try {
      const response = await axios.put(`/transactions/${transaction_id}`)
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Transação alterado com sucesso!'
      })
      dispatch(TRANSACTIONS)
      return response
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível alterar a transação'))
    }
  }

}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/transactions.js